export const InitialConfigBill = {
    rfc: "",
    name: "",
    description: "",
    fiscalRegimeId: "",
    csdPassword: "",
    b64Cer: "",
    b64Key: "",
    logoId: "",
    postalCode: "",
    primaryColor: "#000000",
  };
  
  export const ConfigBillFilled = (data) => {
    return {
      rfc: data?.rfc ?? "",
      name: data?.name ?? "",
      description: data?.description ?? "",
      fiscalRegimeId: data?.fiscalRegime ?? "-99",
      updateAt: String(data?.updatedAt) ?? "",
      // csdPassword: data?.csdPassword ?? "",
      b64Cer: data?.csdCert ?? "",    
      b64Key: data?.csdKey ?? "",    
      logoId: "",
      logoUrl: data.logoUrl || "",
      postalCode: data?.postalCode ?? "",
      primaryColor: data?.primaryColor ?? "",
    };
  };